import React from 'react';
import IntegratedGolfGame from './IntegratedGolfGame';

function App() {
  return <IntegratedGolfGame />;
}

export default App;
